export const getFirstValueTrue = <T>(array: Array<T>): T | undefined =>
  array.find(v => v);
